<script lang="ts">
    import Popup from "@components/popup/Popup.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import ImageQuoteInside from "./ImageQuoteInside.svelte"
    import { type ImageQuote } from "@utils/image-editor/image-quote"
    export let onExit: () => void
    export let imageQuote: ImageQuote
</script>

<Popup width="max-w-2xl" on:clickoutside={onExit} scrollable={false}>
    <PopupExit on:exit={onExit} />
    <ImageQuoteInside {imageQuote} />
</Popup>
